export const userEn = {
  user: {
    guest: 'Guest',
    menu: {
      title: 'User menu',
    },
    avatar: {
      alt: 'User avatar',
      guestAlt: 'Guest avatar',
    },
    profile: {
      title: 'Profile',
      edit_button: 'Edit Profile',
      subtitle: 'Your public information and account details.',
      user_id_label: 'User ID',
      no_profile: 'No profile data available',
      auth_required_title: 'Authentication Required',
      auth_required_message: 'Log in to use all app features',
      login_button: 'Log In',
      register_button: 'Sign Up',
    },
    edit: {
      title: 'Edit Profile',
      subtitle: 'Update your name, email, and avatar.',
      name_label: 'Name',
      name_placeholder: 'Enter your name',
      name_required: 'Name is required',
      email_label: 'Email',
      email_placeholder: 'Enter your email',
      email_invalid: 'Invalid email address',
      avatar_label: 'Avatar URL',
      avatar_placeholder: 'https://www.gravatar.com/avatar/...',
      avatar_invalid: 'Avatar URL must be from an allowed provider (e.g., Gravatar)',
      avatar_help: 'Only URLs from trusted providers like Gravatar are allowed',
      generate_gravatar: 'Generate Gravatar URL from email',
      email_required_for_gravatar: 'Email is required to generate Gravatar URL',
      gravatar_generated: 'Gravatar URL generated',
      gravatar_generation_failed: 'Failed to generate Gravatar URL',
      cancel: 'Cancel',
      save_changes: 'Save Changes',
      show_public_profile: 'Show Public Profile',
    },
    publicProfile: {
      not_found: 'User profile not found',
      not_public: 'This user profile is not public',
      error: 'Failed to load user profile',
      error_title: 'Profile Not Available',
      public_containers: 'Public Containers',
      no_containers: 'No public containers',
      no_containers_description: 'This user has not shared any public containers yet',
    },
    roles: {
      admin: 'Admin',
      owner: 'Owner',
      premium: 'Premium',
    },
  },
}

